import {
  ADD_TAG,
  CAMPAIGN_EDITOR_PAGE_LOADED,
  CAMPAIGN_EDITOR_PAGE_UNLOADED,
  UPDATE_FIELD_FREAK_CAMPAIGN,
  UPLOAD_FREAK_IMAGE,
  UPLOAD_FREAK_VIDEO,
  CAMPAIGN_SUBMITTED,
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case CAMPAIGN_EDITOR_PAGE_LOADED:
      return {
        ...state,
        campaignSlug: action.payload ? action.payload.campaign.slug : '',
        title: action.payload ? action.payload.campaign.title : '',
        description: action.payload ? action.payload.campaign.description : '',
        images: action.payload ? action.payload.campaign.images : '',
        body: action.payload ? action.payload.campaign.body : '',
        startDate: action.payload ? action.payload.campaign.startDate : null,
        participants: action.payload ? action.payload.campaign?.participants : [],
        isPrivate: action.payload ? !action.payload.campaign.public : null
      };
    case CAMPAIGN_EDITOR_PAGE_UNLOADED:
      return {};
    case CAMPAIGN_SUBMITTED:
      return {
        ...state,
        inProgress: null,
        errors: action.error ? action.payload.errors : null
      };
    case UPDATE_FIELD_FREAK_CAMPAIGN:
      return { ...state, [action.key]: action.value };
    case ADD_TAG:
      return {
        ...state,
        tagList: state.tagList.concat([state.tagInput]),
        tagInput: ''
      };
    case UPLOAD_FREAK_IMAGE:
      return {
        ...state,
        imagesToUpload: action.payload ? action.payload.imagesToUpload : '',
        errors: action.error ? action.payload.errors : null
      };
    case UPLOAD_FREAK_VIDEO:
      return {
        ...state,
        videosToUpload: action.payload ? (state.videosToUpload || []).concat(action.payload.videosToUpload) : '',
        errors: action.error ? action.payload.errors : null
      };
    default:
      return state;
  };
};
